module.exports = __webpack_public_path__ + "static/media/mastercard.a1ffa65b.svg";